/**
 *
 * newTreatmentResultStep
 *
 */
import {Component} from "react";
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {createStructuredSelector} from "reselect";
import {compose} from "redux";
import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";
import {
  makeSelectTimeSlot,
  makeSelectTimeWindow,
  makeSelectTreatmentToPlan,
} from "containers/NewTreatmentPage/selectors";
import LoadingAnimation from "basicComponents/LoadingAnimation/LoadingAnimation";
import Button from "basicComponents/ActionButton/ActionButton";
import GlobalMessages from "messages/messages";
import styled from "styled-components";
import LinkButton from "basicComponents/LinkButton/LinkButton";
import moment from "moment";
import Teeth from "images/Gebid.png";
import {isEditingPlannedTreatment} from "containers/NewTreatmentPage/actions";
import reducer from "./reducer";
import saga from "./saga";
import {planActivityAction} from "./actions";
import {makeSelectLoading, makeSelectPlanActivityResult, makeSelectPlanActivityResultError} from "./selectors";
import PatientDetails from "./NewTreatmentResultStepPatientDetails";
import {DATE_FORMATS} from "../../../utils/Date";
import {clearTreatmentFromTimeSlotAction} from "../../PageState/actions";
import NewTreatmentHeader from "../../NewTreatmentHeader/NewTreatmentHeader";
import {makeSelectInsurersApp} from "../../App/selectors";
import history from "../../../utils/history";
import RefrezhButton from "components/RefrezhButton";
import { DEFAULT_LOCALE } from "i18n";
import { getBearer } from "utils/userStorage";

export class NewTreatmentResultStep extends Component {
  // static propTypes = {
  //   planActivity: PropTypes.func.isRequired,
  //   planning: PropTypes.object.isRequired,
  //   loading: PropTypes.bool,
  //   onContinue: PropTypes.func.isRequired,
  //   timeSlot: PropTypes.object,
  //   treatmentToPlan: PropTypes.object.isRequired,
  //   setEditingTreatment: PropTypes.func.isRequired,
  //   planActivityResult: PropTypes.object,
  //   error: PropTypes.object,
  //   patient: PropTypes.object.isRequired,
  //   insurers: PropTypes.array,
  //   clearTreatmentTimeSlot: PropTypes.func.isRequired,
  // };

  static defaultProps = {
    insurers: [],
  };

  state = {

  }

  componentDidMount() {

    window.isloaded = false
    window.loadcount = 0
    //get patient
    var patientid = document.location.pathname.split('/')[3]
    window.getPaul("patient","id",parseInt(patientid),(data) => {
      this.setState({
        patient:data[0],
        withHomeShipping:data[0].homeShipping,
      },() => {
        window.loadcount++
        this.afterLoad()
      })
    })
    // var inp = document.querySelector("#commentinput")
    let params = new URLSearchParams(document.location.search);
    let ptid = params.get("plannedtreatmentid");

    window.getPaul('plannedTreatment',"id",ptid,(data) => {
      this.setState({
        currentTreatmentPlan: data[0],
      },() => {

        window.loadcount++
        this.afterLoad()
      });
    })




    fetch(`${__URLS__["api"]}practices/allTreatments`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
    })
    .then(res => res.json())
    .then(alltreatments => {
      window.getPaul("plannedTreatment","id",ptid,(plannedtreatments) => {
        window.getPaul("treatmentPlan","id",plannedtreatments[0].treatmentPlanId,(treatmentplans) => {
          var tr = alltreatments.find(t => t.id == plannedtreatments[0].treatmentId)
          var duration = tr.duration
          tr.treatmentPlan = treatmentplans[0]
          this.setState({
            alltreatments:alltreatments,
            plannedTreatment2:plannedtreatments[0],
            treatment2:tr,
            description:treatmentplans[0].description,
            treatmentPlan:treatmentplans[0],
          },() => {

            window.loadcount++
            this.afterLoad()
          })
        })
      })
    })

    if (this.props.timeSlot) {
      this.props.planActivity(this.props.planning, this.props.timeSlot.id);
    } else {
      this.props.planActivity(this.props.planning);
    }
  }

  afterLoad(){
    if(window.loadcount < 3){
      return
    }
    this.setState({loaded:true})
    window.isloaded = true
  }

  componentWillUnmount() {
    this.props.clearTreatmentTimeSlot();
  }

  shouldShowPopUp() {
    return this.props.treatmentToPlan && this.props.treatmentToPlan.showPopUp;
  }

  handleContinue = () => {
    // After editing a treatment, make sure to not edit it again.
    this.props.setEditingTreatment(true);
    this.props.onContinue();
  };

  handleClose = () => {
    history.push("/dashboard");
  };

  render() {
    if(this.state.loaded == undefined){
      return null
    }
    console.log('resultstep')
    const done = !this.props.loading && this.props.planActivityResult;
    const error = !this.props.loading && this.props.error;

    return (
      <Wrapper>
        <NewTreatmentHeader
          newMessage={GlobalMessages.thanks_for_your_planned_appointment}
          editingMessage={GlobalMessages.thanksForEditingAppointment}
          onClose={this.props.onClose}
          enableLargePadding
        />
        {this.props.loading && (
          <LoadingAnimation contained containedVertical />
        )}
        {error && (
          <FormattedMessage {...GlobalMessages.somethingWentWrong} />
        )}
        {done && (
          <>
            <SuperContentWrapper>
              <InfoWrapper data-cy="resultInfo">
                <InfoHeaderWrapper>
                  <InfoHeader>
                    <InfoHeaderContent>
                      <StyledSpan>
                        <AppointmentOverview>
                          <FormattedMessage
                            {...GlobalMessages.appointment_overview}
                          />
                        </AppointmentOverview>
                      </StyledSpan>
                      <RefrezhCaseNumber>
                        <FormattedMessage
                          {...GlobalMessages.new_treatment_case_number}
                        />
                        <StyledSpan>
                          {this.props.planActivityResult.patientCaseId}
                        </StyledSpan>
                      </RefrezhCaseNumber>
                    </InfoHeaderContent>
                  </InfoHeader>
                </InfoHeaderWrapper>
                <InfoContentWrapper>
                  <InfoContentHeaderWrapper>
                    <InfoContentHeaderContent>
                      <FormattedMessage
                        {...GlobalMessages.treatment_result_header}
                      />
                    </InfoContentHeaderContent>
                  </InfoContentHeaderWrapper>
                  <InfoContentHeaderContentWrapper>
                    <InfoContentHeaderWrapper>
                      <PatientDetails

                        // here
                        planning={this.props.planning}
                        insurers={this.props.insurers}
                        patient={this.state.patient}
                        endProductName={
                          this.props.planActivityResult.endProductTypeName
                        }
                        treatment={this.state.plannedTreatment2}
                        result={this.props.planActivityResult}
                        date={moment(
                          this.props.planActivityResult.planned_date_time_from,
                        ).format(DATE_FORMATS.HUMAN_READABLE_DATE)}
                        time={moment(
                          this.props.planActivityResult.planned_date_time_from,
                        ).format(DATE_FORMATS.HUMAN_READABLE_TIME)}
                      />
                    </InfoContentHeaderWrapper>
                    <ImageWrapper>
                      <img src={Teeth} alt="Gebid" style={{ height: "100%" }} />
                    </ImageWrapper>
                  </InfoContentHeaderContentWrapper>
                </InfoContentWrapper>
              </InfoWrapper>

              {this.shouldShowPopUp() && (
                <ConditionalText>
                  <ConditionalTextContent>
                    <span>{this.props.treatmentToPlan.popUpMessage}</span>
                  </ConditionalTextContent>
                </ConditionalText>
              )}
            </SuperContentWrapper>

            {/* {!this.shouldShowPopUp() && (
              <ButtonWrapper>
                <Button onClick={this.handleContinue} id="planNextAppointment">
                  <FormattedMessage
                    {...GlobalMessages.schedule_the_follow_up_appointment}
                  />
                </Button>
              </ButtonWrapper>
            )} */}
            <ButtonWrapper>
              <RefrezhButton style={{background:'white',marginTop:'10px'}} onClick={() => {
                history.push(`/patient/${this.props.patient.id}`)
              }}>Naar patientkaart</RefrezhButton>
            </ButtonWrapper>
            <LinkButtonWrapper>
              <LinkButton
                onClick={this.handleClose}
                underline
                id="backToDashboardLinkButton"
              >
                <FormattedMessage {...GlobalMessages.go_back_to_dashboard} />
              </LinkButton>
            </LinkButtonWrapper>
          </>
        )}
      </Wrapper>
    );
  }
}

const ConditionalTextContent = styled.div`
  height: inherit;
  width: 100%;
  padding-left: 0px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  overflow-y: auto;
  padding-left: ${({ theme }) => theme.padding}rem;
  padding-left: ${({ theme }) => theme.padding}rem;
  text-align: center;

  @media (min-width: 1590px) {
    width: calc(100% + 110px);
  }

  width: 37rem;

  @media (min-width: 1048px) {
    width: 43rem;
  }

  ${({ theme }) => theme.phone`
    width: 100%;
  `};
`;

const SuperContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;

  @media (min-width: 1590px) {
    flex-wrap: nowrap;
    flex-direction: column;
  }

  ${({ theme }) => theme.phone`
    width: 100%;
  `};
`;

const ConditionalText = styled.div`
  position: relative;



  @media (min-width: 1590px) {
    /* position: absolute;



    width: calc(100% - 484px);

    right: -238px; */

    display: flex;
    justify-content: center;
    margin-left: 0px;
  }

  /* @media (min-width: 1560px) {
    width: calc(100% + 110px);
  }

  @media (min-width: 1484px) {
    width: calc(100% + 66px);
  }

  @media (min-width: 1406px) {
    width: calc(100% + 36px);
  } */

  /* ${({ theme }) => theme.tabletPortraitUp`
    width: calc(100% + 36px);
  `}; */
`;

const InfoContentHeaderContentWrapper = styled.div`
  display: flex;

  ${({ theme }) => theme.phone`
    flex-direction: column;
  `};
`;

const ImageWrapper = styled.div`
  width: 15rem;
  height: 138px;
  margin-top: 20px;
  margin-right: 20px;

  ${({ theme }) => theme.phone`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: ${theme.margin}rem;
  `};
`;

const ButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-top: ${({ theme }) => theme.marginLarge}rem;

  @media (min-width: 1590px) {
    margin-top: 0px;
  }
`;

const LinkButtonWrapper = styled.div`
  width: 100%;
  text-align: center;

  ${({ theme }) => theme.tabletPortraitUp`

  `};
`;

const InfoContentWrapper = styled.div``;

const InfoContentHeaderContent = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-top: ${({ theme }) => theme.marginHuge}rem;
  margin-bottom: ${({ theme }) => theme.marginHuge}rem;
`;

const InfoContentHeaderWrapper = styled.div`
  text-align: center;
`;

const InfoHeaderContent = styled.div`
  padding-top: ${({ theme }) => theme.padding}rem;
  padding-bottom: ${({ theme }) => theme.padding}rem;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Wrapper = styled.div`
  min-height: inherit;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledSpan = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const AppointmentOverview = styled.div`
  padding-left: ${({ theme }) => theme.padding}rem;
`;

const RefrezhCaseNumber = styled.div`
  padding-right: ${({ theme }) => theme.padding}rem;
`;

const InfoHeaderWrapper = styled.div``;

const InfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const InfoWrapper = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  margin-bottom: ${({ theme }) => theme.margin}rem;

  width: 37rem;
  background:white;

  @media (min-width: 1048px) {
    width: 43rem;
  }

  ${({ theme }) => theme.phone`
    width: 100%;
  `};
`;

const mapStateToProps = createStructuredSelector({
  planning: makeSelectTimeWindow(),
  loading: makeSelectLoading(),
  planActivityResult: makeSelectPlanActivityResult(),
  error: makeSelectPlanActivityResultError(),
  timeSlot: makeSelectTimeSlot(),
  treatmentToPlan: makeSelectTreatmentToPlan(),
  insurers: makeSelectInsurersApp(),
});

function mapDispatchToProps(dispatch) {
  return {
    planActivity: (planning, timeSlotId) =>
      dispatch(planActivityAction(planning, timeSlotId)),
    setEditingTreatment: isEditing =>
      dispatch(isEditingPlannedTreatment(isEditing)),
    clearTreatmentTimeSlot: () => dispatch(clearTreatmentFromTimeSlotAction()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "newTreatmentResultStep", reducer });
const withSaga = injectSaga({ key: "newTreatmentResultStep", saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(NewTreatmentResultStep);
